import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../config';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Set by the auth guard when a request came back 401 on an expired session. Without this
  // sentence, being dropped here after pressing Save reads like the save itself failed --
  // which is exactly how "Invalid or expired token" was reported on 2026-09-30.
  const expired = new URLSearchParams(window.location.search).get('expired') === '1';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        setError('Invalid credentials');
        localStorage.removeItem('adminAuth');
        return;
      }

      const data = await response.json();
      if (data?.user?.role !== 'admin') {
        setError('This account does not have admin access');
        localStorage.removeItem('adminAuth');
        return;
      }

      localStorage.setItem('adminAuth', data.access_token);
      if (data.refresh_token) {
        localStorage.setItem('adminRefresh', data.refresh_token);
      }
      navigate('/admin');
    } catch (err) {
      setError('Failed to connect to server');
      localStorage.removeItem('adminAuth');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Admin Login</h2>
        {expired && !error && (
          <div style={{
            background: '#fef3c7', border: '1px solid #f59e0b', color: '#92400e',
            padding: '10px 12px', borderRadius: 6, marginBottom: 12, fontSize: 14,
          }}>
            Your session expired, so your last action was not saved. Sign in again and redo it.
          </div>
        )}
        {error && <div className="error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}
